import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";

export const thorPaginationStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            marginTop: "20px",
        },
        button: {
            width: "78px !important",
            fontWeight: 450,
            textTransform: "uppercase",
            backgroundColor: `${theme.colors.primary.blue500}`,
            color: "white",
            margin: "0px 20px 0px 20px",
            "&:hover": {
                backgroundColor: "rgba(27, 7, 156, 1)",
            },
        },
        selected: {
            borderBottom: "3px solid #5E81F4",
            paddingBottom: "10px",
            margin: "0px 4px 0px 5px",
        },
        unselected: {
            marginTop: "13px",
        },
        buttonDisabled: {
            backgroundColor: "rgba(129, 129, 165, 0.1)",
            color: "#8181A5 !important",
        },

        pagination: {
            "& .MuiPagination-ul": {
                borderRadius: "4px",
            },
            "& .MuiPaginationItem-page.Mui-selected": {
                backgroundColor: "rgba(94, 129, 244, 0.1)",
                color: "rgba(94, 129, 244, 1)",
                borderRadius: "4px",
                fontWeight: 600,
                cursor: "default",
                "&:hover": {
                    backgroundColor: "rgba(94, 129, 244, 0.1)",
                },
            },
            "& .MuiPaginationItem-page": {
                marginLeft: "5px",
                fontWeight: 500,
                // border: `1px solid white`,
                width: "34px !important",
                padding: "7px 14px 7px 14px",
                minWidth: "10px",
                borderRadius: "4px",
                backgroundColor: "#F5F5FA",
                "&:hover": {
                    backgroundColor: "rgba(94, 129, 244, 0.2)",
                    // border: `1px solid ${theme.colors.primary.blue500}`,
                },
            },
        },
    })
);
